import React from 'react';
import { FrameAnimation } from 'common-package';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import { Icon } from '@fuxi/eevee-icon';
import { selectedCurrentCustomer } from '@/store/customer';
import doubleCircleImg from '@/assets/image/double-circle.svg';
import InfoCard from '../../WeightLoss/info-card';
import { BODYPAIN_CARD_2_TEXT, BODYPAIN_CARD_CONFIG } from '../../utils';
import { setBodyPainShowType, useBodyPainAdjustStore } from '../useBodyPainAdjustStore';

import cx from './index.module.scss';
import { storagePrefixV2 } from '@/constant';

interface Props {}

const ShowBodyPainWaist: React.FC<Props> = () => {
  const showType = useBodyPainAdjustStore.use.showType();
  const currentCustomer = useSelector(selectedCurrentCustomer);

  return (
    <motion.div className={cx('ShowWaist')}>
      <motion.div
        className="info-card"
        transition={{ duration: 0.2 }}
        initial={{ top: '25%', opacity: 0 }}
        animate={{ top: '15%', opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <InfoCard isBodyPainAdjust={true} onClickClose={() => setBodyPainShowType('all')} />
      </motion.div>
      <motion.div className={cx('connection-line')} exit={{ display: 'none', transition: { duration: 0 } }} />
      <motion.div
        className={cx('model-wrapper')}
        style={
          currentCustomer?.gender === 'Male'
            ? {
                backgroundImage: `url(${storagePrefixV2}/ai-consulation/male-model-bg/asdqfqwf-min.png)`,
              }
            : {}
        }
        transition={{ duration: 0.3 }}
        initial={{ left: '-5%', opacity: 0.2 }}
        animate={{ left: '-2%', opacity: 1 }}
        exit={{ left: '3%', opacity: 0 }}
      />
      <motion.div
        className={cx('animation-wrapper', currentCustomer?.gender)}
        transition={{ delay: 0.2 }}
        initial={{ display: 'none' }}
        animate={{ display: 'block' }}
        exit={{ display: 'none', transition: { duration: 0 } }}
      >
        {currentCustomer?.gender === 'Female' ? (
          <FrameAnimation
            aspectRatio={0.853}
            count={99}
            width={246}
            duration={5}
            url="storagePrefixV2/ai-consulation/asfasfqwfqwfq-min.png"
          />
        ) : (
          <FrameAnimation
            aspectRatio={0.787}
            count={99}
            width={246}
            duration={5}
            url="storagePrefixV2/animation/aaaaqsqdq.png"
          />
        )}
      </motion.div>
      <motion.div
        className={cx('part-wrapper')}
        transition={{ duration: 0.5 }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ display: 'none', transition: { duration: 0 } }}
      >
        {BODYPAIN_CARD_CONFIG.map(item => (
          <div
            className={cx('part-card', item.name, { current: item.name === showType })}
            onClick={() => setBodyPainShowType(item.name as any)}
            key={item.name}
          >
            {item.name === showType && <img src={doubleCircleImg} className="double-circle-img" />}
            <div className="part-name">{BODYPAIN_CARD_2_TEXT[item.name]}</div>
            {item.name !== showType && <Icon name="arrow-right" />}
          </div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default ShowBodyPainWaist;
